{
  "title": "Modifier nom FBO",
  "nameLabel": "Nom",
  "cancelButton": "Annuler",
  "saveButton": "Enregistrer"
}
